<template>
  <div class="qa-section">
    <div class="header w1200 clearfix">
      <div class="header-left">
        <div class="hr"></div>
        <h2>QA（Quality Assurance）质量保证体系</h2>
        <h3>SINCE 1961</h3>
      </div>
    </div>
    <div class="content">
      <p>Kids 'R' Kids在中国的幼儿园有符合中美双重安全标准的幼儿园质量保证和运营管理体系。我们在办园条件、园所管理、卫生保健、餐饮服务、教师管理五个方面，十一个模块，五十个类别下有350多条质量标准，大到建筑设施的维护标准，小到幼儿物品标签的张贴要求，涵盖了Kids 'R' Kids园所运营的方方面面。</p>
      <p>为了能够支持每一家园所达到Kids 'R' Kids要求的质量标准，Kids 'R' Kids总部会为所有Kids 'R' Kids中国的园所持续不断地提供关于课程理念、课程实施、幼儿观察、幼儿成长评估、安全监管、卫生保健、质量保证、运营管理、家校沟通、信息系统、家庭服务等一系列的培训。总部还生成了一整套服务于园所日常高标准运营的运营工具。通过每年两次的现场督导支持，辅助园所不断地提高保教服务质量。除了超过200小时的内部质量监控和课程教学方面的培训外，我们每年也有至少两次的Education Review教学检查和支持，以及Quality Assurance Review质量控制体系检查和支持。</p>
      <div class="images1">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img1.jpg">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img2.jpg">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img3.jpg">
      </div>
      <p
        id="kids"
      >Kids 'R' Kids对所有设施设备合作第三方均有严格要求。无论是天花板、墙面，还是地板、地毯，包括幼儿使用的玩教具，均使用国际顶级品牌，打造一流安全环保的园所环境，让孩子们在安全、绿色的环境下生活和学习。</p>
      <p>园所的安全管理，细节是关键。在Kids 'R' Kids的350多项QA质量标准中，例如换尿布即有16个步骤、照料学生如厕有12个步骤等。每个教室都有符合儿童年龄特点的设施，洗手池及卫生间。户外还配有适合不同年龄段的相互独立的活动场所。高标准的质量保证体系，可以确保幼儿园高效运营，安全管理，让婴幼儿在安全、友爱、愉快的环境中生活和游戏。</p>
      <div class="images2">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img4.jpg">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img5.jpg">
      </div>
      <div class="p">
        <p>为有效预防儿童侵害事件发生，在QA标准中我们还有对教师和儿童相处场合的严格规定，例如教师辅助婴幼儿如厕时，不能将门全部关上，需要将门打开或半掩，并且在之前需要告知另一位在班的老师；例如当婴幼儿有身体特殊情况需要在园所内服药时，需要保健医在班级教师的见证下帮助幼儿服药。</p>
        <p>Kids 'R' Kids在中国的幼儿园要求园所每月进行至少一次的安全演习（例如火灾逃生演习、台风、地震逃生演习、防暴演习、防诱拐演习等），让幼儿园的安全防护工作做到极致。 每班配置了适合如地震、火灾等意外灾害事故的防灾应急急救用品，放置在每个班级的出口处。</p>
        <p>幼儿园的各个方面，不论是教室还是校车，我们都为孩子提供最高级别的安全标准。我们的每个幼儿园都会配有密码门禁系统和前台管理人员，并配备适用于家长和安保人员在线观看的监控设备。每间教室的特殊设计，能够确保在紧急情况下，孩子们可以迅速疏散。</p>
        <p>Kids 'R' Kids在中国的幼儿园拥有远高于国家标准的师生比，让老师可以给予幼儿更多关注，进行个性化的指导。</p>
      </div>
      <div class="images3">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img6.jpg">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img7.jpg">
        <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/qa/qa_img8.jpg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.qa-section {
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  .w1200 {
    width: 1200px !important;
    margin: 0 auto;
  }
  .header {
    width: 1200px;
    height: 155px;
    overflow: hidden;
    margin-top: 110px;
    margin-bottom: 93px;
    .header-left {
      float: left;
      .hr {
        width: 96px;
        height: 4px;
        background: rgba(174, 149, 79, 1);
      }
      h2 {
        height: 96px;
        font-size: 48px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 96px;
      }
      h3 {
        width: 180px;
        height: 29px;
        line-height: 29px;
        background: rgba(174, 149, 79, 1);
        font-size: 24px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: bold;
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .content {
    width: 1056px;
    height: auto;
    margin: 0 auto;
    p {
      width: 1056px;
      height: auto;
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
    }
    #kids {
      margin-bottom: 50px;
    }
    p:nth-child(1) {
      margin-bottom: 50px;
    }
    p:nth-child(2) {
      margin-bottom: 47px;
    }
    .images1 {
      width: 1056px;
      height: 230px;
      margin-bottom: 100px;
      img {
        float: left;
        width: 330px;
        height: 230px;
        margin-right: 29px;
      }
      img:last-child {
        margin-right: 0px;
      }
    }
    p:nth-child(3) {
      margin-bottom: 50px;
    }
    .images2 {
      width: 1056px;
      height: 312px;
      margin-top: 37px;
      margin-bottom: 47px;
      img {
        float: left;
        width: 503px;
        height: 312px;
        margin-right: 32px;
      }
      img:last-child {
        margin-right: 0px;
      }
    }
    .p {
      width: 1033px;
      height: auto;
      p {
        width: 1033px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        margin-bottom: 50px;
      }
      p:last-child {
        margin-bottom: 47px;
      }
    }
    .images3 {
      width: 1056px;
      height: 230px;
      margin-bottom: 113px;
      img {
        float: left;
        width: 330px;
        height: 230px;
        margin-right: 29px;
      }
      img:last-child {
        margin-right: 0px;
      }
    }
  }
}
@media (max-width: 767px) {
  .qa-section {
    .w1200 {
      width: 100% !important;
      height: 65px;
    }
    .header {
      width: 100%;
      overflow: hidden;
      margin: 35px 0;
      .header-left {
        width: 100%;
        box-sizing: border-box;
        padding-left: 7.1%;
        .hr {
          width: 56px;
          height: 3px;
        }
        h2 {
          width: 100%;
          height: 41px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          font-family: PingFangSC-Medium;
          padding: 10px 0 8px;
          box-sizing: border-box;
        }
        h3 {
          width: 64px;
          height: 20px;
          font-size: 10px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: normal;
          line-height: 20px;
          background: rgba(174, 149, 79, 1);
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          padding: 0 5px;
        }
      }
    }
    .content {
      width: 100%;
      padding: 0 7.1%;
      box-sizing: border-box;
      p {
        width: 100%;
        height: auto;
        font-size: 14px;
        line-height: 28px;
      }
      .images1 {
        width: 100%;
        height: auto;
        margin-bottom: 60px;
        img {
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 20px;
        }
        img:last-child {
          margin-right: 0px;
        }
      }
      p:nth-child(3) {
        margin-bottom: 50px;
      }
      .images2 {
        width: 100%;
        height: auto;
        margin-bottom: 60px;
        img {
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 20px;
        }
        img:last-child {
          margin-right: 0px;
        }
      }
      .p {
        width: 100%;
        height: auto;
        p {
          width: 100%;
          font-size: 14px;
          line-height: 28px;
          margin-bottom: 50px;
        }
        p:last-child {
          margin-bottom: 47px;
        }
      }
      .images3 {
        width: 100%;
        height: auto;
        margin-bottom: 55px;
        img {
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 20px;
        }
        img:last-child {
          margin-bottom: 30px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/choose/qa.vue